import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class CreateCommand extends AbstractConfDataCommand {
  productId: number;
  parentTabId: number;
}